
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drops",
      function () {
        return require("private-next-pages/drops.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drops"])
      });
    }
  